import { Row, Col } from 'react-bootstrap'
import { CodeIcon, AIIcon, AutomationIcon, ConsultingIcon } from './Icons'

const Services = () => {
    const services = [
        {
            icon: <CodeIcon size={56} />,
            title: "Custom Software Development",
            description: "End-to-end development of web applications, APIs, and backend systems tailored to your business needs.",
            features: ["Web Applications", "REST APIs", "Database Design", "Cloud Deployment"]
        },
        {
            icon: <AIIcon size={56} />,
            title: "AI Integration",
            description: "Integrate artificial intelligence and machine learning capabilities into your existing systems.",
            features: ["Chatbots & Assistants", "Data Analysis", "Process Automation", "LLM Integration"]
        },
        {
            icon: <AutomationIcon size={56} />,
            title: "Workflow Automation",
            description: "Automate repetitive tasks and streamline your business processes for increased efficiency.",
            features: ["Task Automation", "System Integration", "Data Pipelines", "Reporting Tools"]
        },
        {
            icon: <ConsultingIcon size={56} />,
            title: "Technical Consulting",
            description: "Expert guidance on technology decisions, architecture planning, and implementation strategies.",
            features: ["Architecture Review", "Technology Selection", "Security Assessment", "Performance Optimization"]
        }
    ]

    return (
        <Row className="services mx-0" id="services">
            <Row className="mx-0">
                <div className="sectionTitle reveal">
                    Our Services
                </div>
            </Row>
            <Row className="mx-0">
                <div className="sectionDescription reveal">
                    Linko Labs provides custom software and AI integration services for small and medium businesses.
                </div>
            </Row>
            <Row className="servicesGrid mx-0 justify-content-center">
                {services.map((service, index) => (
                    <Col key={index} className="serviceCard col-12 col-md-6 col-lg-5 reveal">
                        <div className="serviceCardInner">
                            <div className="serviceIcon">{service.icon}</div>
                            <h3 className="serviceTitle">{service.title}</h3>
                            <p className="serviceDescription">{service.description}</p>
                            <ul className="serviceFeatures">
                                {service.features.map((feature, idx) => (
                                    <li key={idx}>{feature}</li>
                                ))}
                            </ul>
                        </div>
                    </Col>
                ))}
            </Row>
        </Row>
    )
}

export default Services
